import * as React from 'react';
import { IconName } from '~/common/enums/enums';
import { TechtimeBlockItem } from '~/common/types/types';
import { FormattedMessage, Icon } from '~/components/common/common';
import * as styles from './techtime-item.module.scss';
import { getValidClasses } from '~/helpers/helpers';

type Props = {
  item: TechtimeBlockItem;
  isSelected: boolean;
  className?: string;
  additionalInfo?: React.ReactNode;
  onClick: () => void;
};

const TechtimeItem: React.FC<Props> = ({
  item,
  isSelected,
  className,
  additionalInfo,
  onClick,
}) => {
  const containerClassName = getValidClasses(
    styles.wrapper,
    isSelected && styles.selected,
  );

  return (
    <li className={getValidClasses(className, styles.item)}>
      <button className={styles.button} type="button" onClick={onClick}>
        <div className={containerClassName}>
          <h3 className={styles.title}>
            <FormattedMessage message={item.title} />
          </h3>
          <div className={styles.descriptionWrapper}>
            <FormattedMessage message={item.description} />
          </div>
          <div className={styles.info}>
            <div className={styles.period}>
              <Icon
                iconName={IconName.CALENDAR}
                className={styles.periodIcon}
              />
              <FormattedMessage message={item.period} />
            </div>
            {additionalInfo && <div>{additionalInfo}</div>}
          </div>
        </div>
      </button>
    </li>
  );
};

export { TechtimeItem };
